export type AssistantSlashCommandId = 'skills' | 'standard' | 'deeper' | 'connectors';

export type AssistantSlashCommand = {
  id: AssistantSlashCommandId;
  aliases: readonly string[];
  title: string;
  description: string;
};

export const ASSISTANT_SLASH_COMMANDS: readonly AssistantSlashCommand[] = [
  {
    id: 'skills',
    aliases: ['skills', 'skill'],
    title: 'Skills',
    description: 'Browse versioned assistant skills and insert a starting prompt',
  },
  {
    id: 'standard',
    aliases: ['standard', 'fast'],
    title: 'Standard thinking',
    description: 'Use the default reviewed path for ordinary questions',
  },
  {
    id: 'deeper',
    aliases: ['think', 'deeper', 'reasoning'],
    title: 'Deeper thinking',
    description: 'Spend more budget on hard planning questions',
  },
  {
    id: 'connectors',
    aliases: ['connectors', 'plugin', 'claude', 'chatgpt'],
    title: 'Claude and ChatGPT',
    description: 'Add the Scarlet Sync plugin to Claude or ChatGPT',
  },
];

export function assistantSlashQuery(text: string): string | null {
  const match = /^\/([^\s]*)$/.exec(text.trim());
  return match ? match[1].toLowerCase() : null;
}

export function filterAssistantSlashCommands(text: string): AssistantSlashCommand[] {
  const query = assistantSlashQuery(text);
  if (query === null) return [];
  return ASSISTANT_SLASH_COMMANDS.filter((command) => (
    query.length === 0
    || command.aliases.some((alias) => alias.startsWith(query))
    || (query.length >= 3 && command.title.toLowerCase().includes(query))
  ));
}

export function exactAssistantSlashCommand(text: string): AssistantSlashCommand | null {
  const query = assistantSlashQuery(text);
  if (!query) return null;
  return ASSISTANT_SLASH_COMMANDS.find((command) => command.aliases.includes(query)) ?? null;
}
